import { useAuth0 } from "@auth0/auth0-react";
import { CircularProgress } from "@mui/material";
import LoginContainer from "components/LoginContainer";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store";
import { selectAuth } from "store/slices/user.store";
import AccessDenied from "./AccessDenied";

interface Props {
  children: React.ReactNode;
}

export default function AuthGuard({ children }: Props) {
  const navigate = useNavigate();
  const { email, token, isLoggedIn } = useAppSelector(selectAuth);

  // Component is here to make sure that App is only rendered after authentication has happened

  const { isAuthenticated, loginWithRedirect, isLoading, error } = useAuth0();

  useEffect(() => {
    if (isLoading) return;
    if (!isLoggedIn) {
      navigate("/login", { replace: true });
    } else if (!isAuthenticated && !error) {
      loginWithRedirect({ login_hint: email });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect, error, email, navigate, isLoggedIn]);

  return (
    <>
      {(error && <AccessDenied authError={error} />) ||
        (isAuthenticated && token ? (
          children
        ) : (
          <LoginContainer>
            <CircularProgress color="inherit" />
          </LoginContainer>
        ))}
    </>
  );
}
